import CookieConsentAcceptButton from "./CookieConsentAcceptButton";

export default CookieConsentAcceptButton;
